// Copyright (c) 2026 PGNS LLC

import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@pgns/ui/theme-provider';

/**
 * Light/dark toggle over the shared OKLCH tokens.
 *
 * The page defaults to the reader's system preference: someone reaching a
 * status page at 3am should not be handed a white screen.
 */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  // `theme` can still be 'system', so resolve it the same way ThemeProvider
  // does — otherwise the icon offers "switch to dark" to a reader already in it.
  const isDark =
    theme === 'system'
      ? typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
      : theme === 'dark';
  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className="hover:text-foreground"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? <Sun className="size-4" /> : <Moon className="size-4" />}
    </button>
  );
}
